var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        class: _vm.isMobile && "mt-3",
        attrs: {
          "left-side-class": "col-xl-5",
          page: _vm.pageConfig,
          "right-side-class":
            "col-xl-7 align-items-end d-flex pb-3 justify-content-end"
        }
      }),
      _c("filter-manager", {
        ref: "filter",
        staticClass: "filter-manager_extended",
        attrs: {
          "display-advanced": false,
          filters: _vm.filterManagerConfig,
          "search-container-class": "search-btn"
        },
        on: {
          academicYear: _vm.onAcademicYearChange,
          disciplineType: _vm.onDisciplineTypeChange,
          locationService: _vm.onLocationServiceChange,
          provider: _vm.onProviderChange,
          search: _vm.onSearchHandler
        },
        model: {
          value: _vm.filter.model,
          callback: function($$v) {
            _vm.$set(_vm.filter, "model", $$v)
          },
          expression: "filter.model"
        }
      }),
      _c("support-type-legend"),
      _c("available-hours", {
        attrs: { "is-mobile": _vm.isMobile, options: _vm.sortedHours },
        on: { select: _vm.onSelectHours }
      }),
      _c("visit-calendar", {
        attrs: {
          "academic-year-id": _vm.filter.model.academicYear
            ? _vm.filter.model.academicYear.id
            : null,
          dates: _vm.dates,
          "is-mobile": _vm.isMobile,
          students: _vm.studentsFilter
        },
        on: {
          "on-datarange-changed": _vm.onDatarangeChanged,
          reload: _vm.search
        }
      }),
      _c("div", { staticClass: "col-12" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }